<template>
    <div
        class="nav-wrapper fixed bottom-0 left-0 w-full right-0 z-100 bg-white"
    >
        <nav class="app-nav bg-white">
            <div class="app-nav__inner flex w-full">
                <router-link
                    v-for="nav in navs"
                    :key="nav"
                    :to="nav"
                    class="app-nav__link flex justify-center items-center"
                    :class="{
                        'app-nav__link_active': $route.path === nav,
                    }"
                >
                    <div
                        v-ripple
                        class="app-nav__link-inner flex justify-center items-center"
                        :class="{
                            'justify-between': $route.path === nav,
                        }"
                    >
                        <NavigationIcons :icon="nav" />
                        <span
                            v-if="$route.path === nav"
                            class="text-14 font-bold tracking-normal text-text"
                        >
                            {{ $route.name }}
                        </span>
                    </div>
                </router-link>
            </div>
        </nav>
    </div>
</template>

<script>
import NavigationIcons from "../Icons/NavigationIcons";
export default {
    name: "Navigation",

    components: { NavigationIcons },

    props: [],

    data: function() {
        return {
            navs: ["/dashboard", "/locations", "/settings"],
        };
    },
};
</script>
